import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Box, Button, Grid, withWidth } from "@material-ui/core";
import {
  FilterBar,
  Container,
  DataGrid,
  Paginate,
  InputText,
  Dialog,
} from "src/components";

import {
  Cancel as CancelIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@material-ui/icons";

import {
  excluirCategoria,
  pesquisarCategorias,
} from "src/store/actions/categorias_produtos";
import * as types from "src/store/types/categorias_produtos";
import { Plus as PlusIcon } from "react-feather";
import ModalProdutos from "./ModalProdutos";

function CategoriasProdutos({ width }) {
  const [categoria, setCategoria] = useState({});
  const [modal, setModal] = useState({ type: "", produto: {} });

  const dispatch = useDispatch();
  const { filtro, page, perpage, total, categorias, loading } = useSelector(
    (state) => state.categorias_produtos
  );

  useEffect(() => {
    dispatch(
      pesquisarCategorias({
        ...filtro,
        page,
        per_page: perpage,
      })
    );
  }, []);

  function limparfiltros() {
    dispatch([
      { type: types.SET_PAGE_PRODUTOS_CATEGORIA, payload: 1 },
      { type: types.SET_FILTRO_PRODUTOS_CATEGORIA, payload: { titulo: "" } },
      pesquisarCategorias({ page: 1, per_page: perpage }),
    ]);
  }

  function handleChangePage(newPage) {
    dispatch([
      { type: types.LOADING_PRODUTOS_CATEGORIA, payload: true },
      { type: types.SET_PAGE_PRODUTOS_CATEGORIA, payload: newPage + 1 },
      pesquisarCategorias({
        ...filtro,
        page: newPage + 1,
        per_page: perpage,
      }),
    ]);
  }

  const handleChangeRowsPerPage = (event) => {
    dispatch([
      { type: types.LOADING_PRODUTOS_CATEGORIA, payload: true },
      {
        type: types.SET_PERPAGE_PRODUTOS_CATEGORIA,
        payload: parseInt(event.target.value, 10),
      },
      pesquisarCategorias({
        ...filtro,
        page: 1,
        per_page: parseInt(event.target.value, 10),
      }),
    ]);
  };

  const handleFiltro = (value) => {
    dispatch({
      type: types.SET_FILTRO_PRODUTOS_CATEGORIA,
      payload: value,
    });
  };

  const handleCloseModal = () => {
    setModal({ type: "" });
  };

  const handleDelete = () => {
    excluirCategoria(categoria.id);
    handleCloseModal();
  };

  return (
    <Container title="Categorias de produtos">
      <Dialog
        visible={modal.type === "delete"}
        title="Excluir categoria"
        contenttext="Deseja excluir a categoria ?"
        buttons={[
          {
            title: "Excluir",
            icon: <DeleteIcon />,
            onClick: handleDelete,
          },
          {
            title: "Fechar",
            icon: <CancelIcon />,
            onClick: handleCloseModal,
          },
        ]}
      />
      <ModalProdutos
        open={modal.type !== "" && modal.type !== "delete"}
        type={modal.type}
        close={handleCloseModal}
        produto={modal.produto}
      />
      <Box display="flex">
        <FilterBar
          fullWidth
          searchFilter={pesquisarCategorias({ ...filtro, per_page: perpage })}
          clearFilter={limparfiltros}
          title="Clique aqui para visualizar as opções de filtro."
        >
          <Grid container spacing={2}>
            <Grid item sm={5}>
              <InputText
                label="Categoria"
                value={filtro.titulo}
                onChange={(e) => handleFiltro({ titulo: e.target.value })}
              />
            </Grid>
          </Grid>
        </FilterBar>
        <Button color="primary" onClick={() => setModal({ type: "insert" })}>
          <PlusIcon />
          Novo
        </Button>
      </Box>
      <PerfectScrollbar>
        <DataGrid
          isLoading={loading}
          columns={[
            {
              title: "ID",
              field: "id",
              width: 30,
              headerStyle: { paddingLeft: 10 },
              cellStyle: { paddingLeft: 10 },
              hidden: ["lg", "xl"].includes(width) ? false : true,
            },
            {
              title: "Categoria",
              field: "titulo",
              width: "auto",
              headerStyle: {},
              cellStyle: {},
            },
            {
              title: "Ordem",
              field: "ordem",
              width: 30,
              headerStyle: {},
              cellStyle: {},
            },
          ]}
          data={categorias}
          actions={[
            {
              icon: () => <EditIcon color="primary" />,
              tooltip: "Visualizar",
              onClick: (event, rowData) => {
                setCategoria(rowData);
                setModal({ type: "update", produto: rowData });
              },
            },
            {
              icon: () => <DeleteIcon color="primary" />,
              tooltip: "Extrato",
              onClick: (event, rowData) => {
                setCategoria(rowData);
                setModal({ type: "delete" });
              },
            },
          ]}
        />
      </PerfectScrollbar>
      <Paginate
        rowsPerPageOptions={[10, 25, 50]}
        rowsPerPage={perpage}
        count={total}
        page={page - 1}
        onChangePage={(event, newPage) => handleChangePage(newPage)}
        onChangeRowsPerPage={(e) => handleChangeRowsPerPage(e)}
      />
    </Container>
  );
}

export default withWidth()(CategoriasProdutos);
